// # vendor
import { isEqual } from "lodash";
import { boundMethod } from "autobind-decorator";
// # store
import store from "../store";

/**
 * Helps us synchronise data between redux and angular's root scope.
 */
class AngularRedux {
  /**
   * Angular rootscope object.
   *
   * @var {any}
   */
  protected $rootScope: any = {};

  /**
   * Function that unsubscribes the redux listener.
   *
   * @var {null | (() => void)}
   */
  protected unsubscribeFromStore: null | (() => void) = null;

  constructor($rootScope) {
    this.$rootScope = $rootScope;
  }

  /**
   * Adds a change listener to the redux store.
   *
   * @param {angularRootscope} $rootScope
   * @returns {AngularRedux}
   */
  @boundMethod
  public enableSync(): AngularRedux {
    if (this.$rootScope.isSubscribedToStore) {
      return this;
    }
    this.unsubscribeFromStore = store.subscribe(this.handleStoreChange);
    return this;
  }

  /**
   * Stops listening for changes on the redux store.
   *
   * @returns {AngularRedux}
   */
  @boundMethod
  public disableSync(): AngularRedux {
    if (!this.$rootScope.isSubscribedToStore) {
      return this;
    }
    if (!this.unsubscribeFromStore) {
      return this;
    }
    this.unsubscribeFromStore();
    return this;
  }

  /**
   * Syncs redux data back to $rootScope if any values have changed.
   *
   * @returns {void}
   */
  @boundMethod
  protected handleStoreChange(): void {
    const { siteSettings, user } = store.getState();

    if (!isEqual(this.$rootScope.siteSettings, siteSettings)) {
      this.$rootScope.siteSettings = siteSettings;
    }

    if (!isEqual(this.$rootScope.thisUser, user)) {
      this.$rootScope.thisUser = user;
    }
  }
}

export default AngularRedux;
